import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FeedProfile } from '@vestiaire/api-sdk-angular';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { ISeeMemberEvent } from '../feed-card-profile/feed-card-profile.component';

export interface IHideRecommended {
  profileId: string;
  position: number;
  trackingKey: string;
}

@Component({
  selector: 'vc-feed-suggestions',
  templateUrl: './feed-suggestions.component.html',
  styleUrls: ['./feed-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedSuggestionsComponent implements OnInit {
  @Input() profiles: FeedProfile[];
  @Input() newFollow: boolean;
  hiddenProfileIds: string[];

  @Input() cardType: string;

  @Output() onFollowProfile = new EventEmitter<string>();
  @Output() onSeeProfile = new EventEmitter<ISeeMemberEvent>();
  @Output() onHideProfile = new EventEmitter<IHideRecommended>();

  constructor(private platformService: PlatformService) {}

  ngOnInit() {
    if (this.platformService.isBrowser) {
      this.updateListHiddenProfilesFromStorage();
      this.profiles = this.profiles.filter(profile => !this.hiddenProfileIds.includes(profile.describes.id));
    }
  }

  hideProfileSuggestion(profileId: string): void {
    const position = this.profiles.findIndex(profile => profile.describes.id === profileId);
    const trackingKey = this.profiles[position].trackingKey;
    this.onHideProfile.emit({ profileId: profileId, position: position, trackingKey: trackingKey });

    this.removeOneProfile(profileId);

    if (this.platformService.isBrowser) {
      this.updateListHiddenProfilesFromStorage(profileId);
      localStorage.setItem('profilesHidden', JSON.stringify(this.hiddenProfileIds));
    }
  }

  updateListHiddenProfilesFromStorage(id = null): void {
    this.hiddenProfileIds = JSON.parse(localStorage.getItem('profilesHidden')) || [];
    if (id) {
      this.hiddenProfileIds.push(id);
    }
  }

  removeOneProfile(id): void {
    this.profiles = this.profiles.filter(profile => profile.describes.id !== id);
  }
}
